import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { setVerbalResponseOptions } from '../store/options.actions'
import { VitalsService } from '../../vitals/services/vitals.service'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

import { IOptionsResponse } from '../../../common/common.types'

export function* getVerbalResponseOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const vitalsService = new VitalsService(serviceId)
  try {
    const verbalResponse: IOptionsResponse = yield call([vitalsService, vitalsService.getVerbalResponse])
    const { entity } = verbalResponse
    yield put(setVerbalResponseOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getVerbalResponseOptions() error: ${e}`))
  }
}

export function* getVerbalResponseOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getVerbalResponseOptions)
}
